import { Box, Typography } from "@mui/material";

type Props = {
  date: string;
  title: string;
  tags: string;
  imageUrl: string;
  onClick?: () => void;
};

const UpcomingEventCard = ({ date, title, tags, imageUrl, onClick }: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "stretch",
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: "#f5f5f0",
        cursor: onClick ? "pointer" : "default",
        transition: "opacity 0.15s",
        "&:hover": onClick ? { opacity: 0.88 } : {},
        my: 2,
        width: { xs: "100%", sm: "90%" },
      }}
    >
      {/* Image */}
      <Box
        sx={{
          width: { xs: 120, sm: 160 },
          minWidth: { xs: 120, sm: 160 },
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px 0 0 12px",
        }}
      />

      {/* Body */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 1,
          px: 2.5,
          py: 2.5,
        }}
      >
        {/* Date */}
        <Typography
          variant="caption"
          sx={{
            fontSize: { xs: "10px", sm: "10px" },
            fontWeight: 600,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "text.secondary",
          }}
        >
          {date}
        </Typography>

        {/* Title */}
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: { xs: "12px", sm: "12px" },
            lineHeight: 1.35,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            height: 30,
          }}
        >
          {title}
        </Typography>

        {/* Divider */}
        <Box
          sx={{
            borderTop: "0.5px solid",
            borderColor: "divider",
            my: 0.25,
          }}
        />

        {/* Tags */}
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: { xs: "10px", sm: "10px" },
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {tags}
        </Typography>
      </Box>
    </Box>
  );
};

export default UpcomingEventCard;
